import React from "react";
import Helmet from "react-helmet";
import SEO from "../components/SEO";
import "../assets/css/App.css";
import "../assets/css/index.css";
import Layout from "../components/Layout";
import Contactform from "../components/ContactForm";
import { Link } from "gatsby";
import { Jumbotronv2 } from "../components/Jumbotronv2";
import { ServicesBlock2 } from "../components/ServicesBlock2";
import { RE } from "../components/Reviews";
import { Brands } from "../components/Branding";

export default () => (
  <Layout>
    <SEO
      title="Commercial Boiler Servicing London"
      description="BBIS Heating completes commercial boiler services across London and the surrounding areas. Contact us today."
      keywords="central heating service london,central heating services london,london central heating services,boiler and central heating service
      ,boiler central heating service,central heating service providers,oil central heating service,central heating boiler service,gas central heating service,central
       heating service,central heating services,central heating systems london,gas central heating system installation,oil central heating system,gas central heating
        system,new central heating system,electric central heating systems,central heating system,"
    />
    <Jumbotronv2 imgName={"j4"} headingTag={"Commercial Boiler Servicing"} descriptionTag={"Keep your boiler in good working order in London, Hertfordshire and the surrounding areas"} showOverlay={true} />
    <div class="white-segment">
      <h2 class="heading-color">Keep your boiler running safely and efficiently</h2>
      <p>It’s essential to have your commercial boiler serviced every year to ensure its safe and efficient. Whether you manage an office, shop, warehouse, school or residential property, routine servicing can help prevent breakdowns, reduce long-term costs and keep your heating system performing at its best.</p>
    </div>
    <div className="grey-segment">
      <h2 class="heading-color">Protect your boiler and your business</h2>
      <p>Our Gas Safe-registered engineers will carry out a full inspection of your commercial boiler, checking for faults, cleaning the components and ensuring your system complies with manufacturer requirements and Gas Safety regulations.</p>
      <p>This helps to:</p>
      <ul>
        <li>Identify and resolve issues before they become costly breakdowns</li>
        <li>Prolong the lifespan of your boiler</li>
        <li>Improve energy efficiency and reduce operating costs</li>
        <li>Ensure your boiler warranty remains valid</li>
      </ul>
        <p>We recommend combining your annual boiler service with your <Link to="/commercial-gas-safety-check/"></Link>gas safety inspection for maximum convenience.</p>
      </div>
      <div className="white-segment">
      <h2 class="heading-color">Why choose BBIS Commercial Heating?</h2>
      <ul>
        <li>Expert servicing for gas, oil, LPG and electric systems</li>
        <li>Trusted by offices, retail premises and landlords across London</li>
        <li>Over 50 years of heating industry experience</li>
        <li>Friendly, reliable local engineers</li>
        <li className="pb-4">Same or next working day appointments available</li>
      </ul>
      <ServicesBlock2></ServicesBlock2>
      <Brands></Brands>
      </div>
      <div className="grey-segment">
      <h3 class="heading-color">What our customers say</h3>
      <RE></RE>
      </div>
      <div className="white-segment">
      <h3 class="heading-color">We provide gas safety inspections across London, Hertfordshire and surrounding areas</h3>
      <p>BBIS Commercial Heating Ltd has been supporting businesses and landlords with professional boiler servicing for over five decades. Contact us today to schedule your commercial boiler service or arrange a combined service and gas safety inspection.</p>
      <Contactform></Contactform>
    </div>
  </Layout>
);
